<template>
    <header class="header_border">
        <teleport to="body">
            <div v-if=state.isLoading>
                <base-spinner />
            </div>
        </teleport>
        <div class="header_nav">
            <div class="topmenu">
                <div class="logo">
                    <router-link to='/dashboard'>
                        <img src="image/logo.svg" />
                    </router-link>
                </div>
                <div class="system">
                    <div v-if="!isLoggedIn">
                        <button class="login-button" @click="router.push('/login')">관리자 로그인</button>
                        <button class="member">계정 생성</button>
                    </div>
                    <div v-else>
                        <button class="login-button">{{ name }} 님</button>
                        <button class="logout" @click="logoutUser()">로그아웃</button>
                    </div>

                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
    setup() {
        const store = useStore()
        const router = useRouter()

        const name = computed(() => store.getters['login/getName'])
        const isLoggedIn = computed(() => store.getters['login/isAuthenticated'])
        const state = reactive({
            isLoading: false,
            name: name
        })
        const logoutUser = async () => {
            if (name.value !== '') {
                state.isLoading = true;
                try {
                    await store.dispatch('login/requestLogout', { 'id': name.value })
                } catch (error) {
                    console.error('Logout failed:', error);
                } finally {
                    state.isLoading = false;
                    router.replace('/login');
                }
            }
        }
        return { state, name, isLoggedIn, logoutUser, router }
    }
};
</script>

<style scoped>
img {
    margin: 0;
    padding: 0;
    font-size: 100%;
    box-sizing: border-box;
    border: none;
}

label,
button {
    cursor: pointer;
}

button:focus {
    outline: none;
}

img,
button {
    border: 0 none;
    vertical-align: top;
}

button {
    background-color: transparent;
}

.header_border {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    border-width: 0px 0px 2px 0px;
    border-style: solid;
    border-color: #90A4AE;
}

.header_nav {
    width: 100%;
    height: 78px;
    background-color: #263238;
    /* border: 0 0 1px 0;
    border-color: #90a4ae; */
}

.topmenu {
    padding: 20px 0;
    width: 100%;
    margin: 0 auto;
    padding: 10px 20px;
    display: inline-flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
}

.system>button::before {
    display: inline-block;
    content: "/";
    padding: 0 10px;
    columns: #e0e0e0;
}

.system>button:nth-of-type(1)::before {
    display: none;
}

.system>button {
    color: #cfd8dc;
}

/* .topmenu .contentbox {
} */
.logo img {
    width: 270px;
    height: 30px;
}

.login-button {
    color: #E0E0E0;
    padding: 0.5rem 0.5rem 0.5rem 0.5rem
}

.member {
    color: #E0E0E0;
    padding: 0.5rem 0.5rem 0.5rem 0.5rem
}

.logout {
    color: #E0E0E0;
    padding: 0.5rem 0.5rem 0.5rem 0.5rem
}
</style>